export default "__VITE_ASSET__DcCXxSDj__"